import React from 'react';
import { Container, Row, Col, Form, Button, ProgressBar, InputGroup } from 'react-bootstrap';
import { useLocalStorage } from "../../useLocalStorage";
import config from './config.json';

const Step3 = ({ prevStep, nextStep }) => {
const currentStep = 3;

  const [dataLocal, setDataLocal] = useLocalStorage("audit_energetique", { 
    habitable_surface: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataLocal({...dataLocal, [name]: value});
    };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation et logique supplémentaire ici
    nextStep();
  };

  return (
    <Container>      
      <ProgressBar
        now={(currentStep / config.totalSteps) * 100}
        style={{ backgroundColor: "#bad7f1" }}
      >
      <ProgressBar
        now={(currentStep / config.totalSteps) * 100}
        style={{ backgroundColor: "#0be288" }}
      />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
            <Col>
                <h2>{config.step3.step}</h2>
                <h3>{config.step3.title2}</h3>
                <p></p>
            </Col>
        </Row>
        <Row className="mb-3 justify-content-center">
          {/* <Col lg={{ span: 6, offset: 3 }}> */}
          <Col lg={6} offset-lg={3}>
            <Form.Group controlId="habitableSurface">
              <Form.Label>{config.step3.label}</Form.Label>

              <InputGroup>
                <Form.Control
                  type="number"
                  name="habitable_surface"
                  placeholder="Entrez la surface chauffée"
                  value={dataLocal.habitable_surface}
                  onChange={handleChange}
                  min="0"
                  required
                />
                <InputGroup.Text id="basic-addon1">m²</InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button type="button" variant="secondary" onClick={prevStep}>
              Précédent
            </Button>
            <Button type="submit" variant="primary" disabled={!dataLocal.habitable_surface ? true : false} className="ms-3">
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step3;